module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Other2-c46d0c7d7303b1e7e31f9404b3585324.svg";